import type { PropsWithChildren } from 'react';

import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { PATH_DASHBOARD } from '../../routes/paths';

type Tab = {
  label: string;
  value: string;
};

export const defaultTabs: Tab[] = [
  {
    label: 'profile',
    value: 'profile',
  },
  {
    label: 'NOTES',
    value: 'accounting/notes',
  },
  {
    label: 'change_password',
    value: 'change-password',
  },
];

type UserDetailsNavigatorContextType = {
  currentTab: string;
  id: string;
  tabs: Tab[];
};

const defaultUserDetailsNavigatorContextValue = {
  currentTab: 'profile',
  id: '',
  tabs: defaultTabs,
};

export const UserDetailsNavigatorContext =
  createContext<UserDetailsNavigatorContextType>(
    defaultUserDetailsNavigatorContextValue
  );

type UserDetailsNavigatorContextProviderProps = PropsWithChildren<any>;

export const UserDetailsNavigatorContextProvider = ({
  children,
}: UserDetailsNavigatorContextProviderProps) => {
  const [contextValue, setContextValue] =
    useState<UserDetailsNavigatorContextType>(
      defaultUserDetailsNavigatorContextValue
    );

  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    if (id) {
      setContextValue((prev) => ({ ...prev, id }));

      if (pathname) {
        let currentTab = pathname.replace(
          `${PATH_DASHBOARD.user.details(id)}/`,
          ''
        );
        currentTab = currentTab || defaultTabs[0].value;

        setContextValue((prev) => ({ ...prev, currentTab }));
      }
    } else {
      navigate(PATH_DASHBOARD.user.list);
    }
  }, [id, navigate, pathname]);

  return (
    <UserDetailsNavigatorContext.Provider value={{ ...contextValue }}>
      {children}
    </UserDetailsNavigatorContext.Provider>
  );
};

export const useUserDetailsNavigatorContext = () => {
  return useContext(UserDetailsNavigatorContext);
};
